import type { CoreEstimateInsuranceForQuote, ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

export async function getEstimateInsuranceForQuote(
  item_internal_id: ParameterID,
  options: GetEstimateInsuranceForQuoteOptions
): Promise<CoreEstimateInsuranceForQuote> {
  const response = await api.get(
    `/api/saas/me/items/${item_internal_id}/insurance/quote`,
    {
      params: options,
    }
  )

  return response.data.insurance_quote
}

export type GetEstimateInsuranceForQuoteOptions = {
  start_at: string
  end_at: string
  quantity: number
  rental_cents?: number
  unit_incidence_value?: number
}
